import React, { useState } from "react";
import { Redirect, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  MDBBox,
  MDBBtn,
  MDBBtnGroup,
  MDBContainer,
  MDBCard,
  MDBCardTitle,
  MDBCardText,
  MDBCardFooter,
  MDBIcon,
  MDBBadge,
} from "mdbreact";

import HowToCreateModal from "components/HowToCreatePostModal";
import NoItems from "components/ui-components/no-items";
import EditPostModal from "components/EditPostModal";
import DeletePostModal from "components/DeletePostModal/DeletePostModal";

import { sortByDate, FROM_NEWER_TO_OLDER } from "helpers/sortByDate";
import { Maybe } from "helpers/maybeFunctor";
import formatTime from "helpers/formatTime";
import { url as urlApi } from "api";

import "./PostsPageSuperAdmin.scss";
import CreatePostModal from "components/CreatePostModal";
import { setSelectedPost } from "actions/posts";
import { PlatformIcon } from "components/SocialMediaBrand/SocialMediaBrand";

const StatusBadge = ({ status }) => {
  const getStatusColor = (status) => {
    const statusColors = {
      pending_subject: 'warning',
      approved_subject: 'info',
      pending_content: 'warning',
      approved_content: 'success',
      pending_posting: 'primary',
      approved_posting: 'success',
      pending_archiving: 'secondary',
      approved_archiving: 'info'
    };
    return statusColors[status] || 'light';
  };

  return (
    <MDBBadge color={getStatusColor(status)} className="mx-2">
      {status.replace(/_/g, ' ')}
    </MDBBadge>
  );
};

const PostsPageSuperAdmin = (props) => {
  const dispatch = useDispatch();
  const { brandId, idUser, companyId } = props;
  const [modal, setModal] = useState("");
  const [postToEdit, setPostToEdit] = useState("");
  const [postToDelete, setPostToDelete] = useState("");
  const [linkToDownloadForJson, setLinkToDownloadForJson] = useState(null);

  const brandsRedux = useSelector((s) => s.superAdmin.company_brands)?.filter(compItem => compItem._id === companyId)?.flatMap(x => x.brands);

  const mainAdmin = useSelector((s) => s.user.userInfo.superAdmin);

  if (!brandsRedux) {
    return <Redirect to={`/super-admin`} />;
  }

  const neededProject = brandsRedux.find((projectItem) => {
    return projectItem._id === brandId;
  });

  const maybePosts = Maybe.of(neededProject.posts)
    .map((posts) => {
      return sortByDate(posts, FROM_NEWER_TO_OLDER);
    })
    .map((posts) => {
      return posts.map((postItem) => {
        const { title, textContent, targetedSocialAccounts, statusKey, prompt, type, scheduled_at, _id } =
          postItem;

        return (
          <MDBCard className="main-bid-card mt-2 min-h-screen" key={_id}>
            <div className="w-100 m-auto">
            <MDBCardTitle className="d-flex justify-content-between">
              <span className="font-size-2">{title}</span>
              <span className="font-size-1">{formatTime(scheduled_at)}</span>
            </MDBCardTitle>
            <MDBCardText className="font-size-1">{textContent}</MDBCardText>
            <StatusBadge status={statusKey} />
            {targetedSocialAccounts?.map(x =>
            <div className="d-flex align-items-center">
              <PlatformIcon platform={x.platform} />
              <span className="ml-2">{x.platform}</span>
            </div>
          )}
            {/* <MDBCardFooter className="bg-transparent p-0 border-0 d-flex justify-content-between">
              <MDBBtnGroup className="w-50">
               
                {linkToDownloadForJson}
                <a
                  className="bg-bid border-bid text-inherit text-white card-button d-flex align-items-center justify-content-center btn-radius ml-0"
                  href={`${urlApi}/${excel}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                ><i className="fa fa-download mr-2"></i>
                  Download Estimation
                </a>
                <a
                  className="bg-white border-bid text-inherit text-bid card-button d-flex align-items-center justify-content-center btn-radius"
                  href={`${urlApi}/${excelQuant}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                ><i className="fa fa-download mr-2"></i>
                  Download Quantity
                </a>
              </MDBBtnGroup>
              <MDBBtnGroup className="ml-auto">
                <MDBBtn
                  color=""
                  size="sm"
                  className="see-btn mr-3 action-btns ml-auto"
                  onClick={() => {
                    setModal("EditPost");
                    dispatch(setSelectedPost(postItem))
                    setPostToEdit(postItem);
                  }}
                >
                  <MDBIcon icon="edit" className="font-size-1" />
                </MDBBtn>
                <MDBBtn
                  color=""
                  size="sm"
                  className="dlt-btn action-btns"
                  onClick={() => {
                    setModal("DeletePost");
                    setPostToDelete(postItem);
                  }}
                >
                  <MDBIcon icon="trash" className="font-size-1" />
                </MDBBtn>
              </MDBBtnGroup>
            </MDBCardFooter> */}
            </div>
          </MDBCard>
        );
      });
    });

  const { value: postsToJSX } = maybePosts;

  return (
    <div className="posts-page">
      <div className="inner-header-position">
        <div className="custom-container d-flex align-items-center justify-content-between py-3">
          <p className="my-heading">
            Posts{" "}
            {/* {mainAdmin ? (
              <MDBBtn
                size="sm"
                className="pink darken-1"
                onClick={() => setModal("HowToCreatePost")}
              >
                How to create post?
              </MDBBtn>
            ) : null} */}
            
          </p>
          {/* <div className="d-flex align-items-center project-admin-header ">
           <i className="fa fa-home mr-2"></i> Calendar: 
            <strong className="ml-2">{neededProject.title}</strong>
          </div> */}
        </div>
      </div>
      <MDBContainer size="lg" className="pt-12">
        <MDBBox className="pt-3">
          <div className="d-flex flex-row gap-2">
            {neededProject.posts.length === 0 ||
            !neededProject.posts ? (
              <NoItems text="This brand has no posts" />
            ) : null}
            {postsToJSX}
          </div>
        </MDBBox>
      </MDBContainer>
      <HowToCreateModal
        id={neededProject._id}
        isOpen={modal === "HowToCreatePost"}
        toggle={() => setModal("")}
      />
      {modal === "EditPost" && (
        <CreatePostModal
          id={brandId}
          isOpen={modal === "EditPost"}
          toggle={() => setModal("")}
        />
      )}
      <DeletePostModal
        isOpen={modal === "DeletePost"}
        toggle={() => setModal("")}
        itemToDelete={
          postToDelete ? { posts_id: postToDelete._id } : null
        }
      />
    </div>
  );
};

export default PostsPageSuperAdmin;
